import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';

import { UserModuleAnswersGeneratedLinkedinProposition } from 'user/user-module-answers-generated-linkedin-proposition';

import { UserModulePage } from './user-module-page';

export interface IUserModule extends IEntity {
	readonly userId: string;
	readonly isDone: boolean;
	readonly moduleId: string;
	readonly isStarted: boolean;
	readonly coachComment: string;
	readonly moduleRatingComment: string;
	readonly moduleRatingValue: number;
	readonly isDescriptionVisualized: boolean;
	readonly pages: ReadonlyArray<UserModulePage>;
	readonly generatedUserModulePitch: string;
	readonly generatedUserModuleSynthesis: string;
	readonly generatedUserModulePushSynthesis: string;
	readonly generatedUserModulePushQuestionsSynthesis: { [key: string]: string };
	readonly generatedUserModuleLinkedinProposition: UserModuleAnswersGeneratedLinkedinProposition[];

	getActivityUrl(id: string): string;
}

export class UserModule extends Entity implements IUserModule {
	private _userId: string;
	private _isDone: boolean;
	private _moduleId: string;
	private _isStarted: boolean;
	private _coachComment: string;
	private _pages: UserModulePage[];
	private _moduleRatingComment: string;
	private _moduleRatingValue: number;
	private _isDescriptionVisualized: boolean;
	private _generatedUserModuleSynthesis: string;
	private _generatedUserModulePitch: string;
	private _generatedUserModulePushSynthesis: string;
	private _generatedUserModulePushQuestionsSynthesis: { [key: string]: string };
	private _generatedUserModuleLinkedinProposition: UserModuleAnswersGeneratedLinkedinProposition[];

	constructor(
		userId: string,
		isDone: boolean,
		moduleId: string,
		isStarted: boolean,
		coachComment: string,
		moduleRatingComment: string,
		moduleRatingValue: number,
		pages: UserModulePage[],
		updateTimestamp: number,
		isDescriptionVisualized: boolean,
		generatedUserModuleSynthesis: string,
		generatedUserModulePitch: string,
		generatedUserModulePushSynthesis: string,
		generatedUserModulePushQuestionsSynthesis: { [key: string]: string },
		generatedUserModuleLinkedinProposition: UserModuleAnswersGeneratedLinkedinProposition[]
	) {
		super(userId + moduleId, null, updateTimestamp);
		this._pages = pages;
		this._isDone = isDone;
		this._userId = userId;
		this._moduleId = moduleId;
		this._isStarted = isStarted;
		this._coachComment = coachComment;
		this._moduleRatingValue = moduleRatingValue;
		this._moduleRatingComment = moduleRatingComment;
		this._isDescriptionVisualized = isDescriptionVisualized;
		this._generatedUserModulePitch = generatedUserModulePitch;
		this._generatedUserModuleSynthesis = generatedUserModuleSynthesis;
		this._generatedUserModulePushSynthesis = generatedUserModulePushSynthesis;
		this._generatedUserModulePushQuestionsSynthesis =
			generatedUserModulePushQuestionsSynthesis;
		this._generatedUserModuleLinkedinProposition =
			generatedUserModuleLinkedinProposition;
	}

	public get generatedUserModuleLinkedinProposition(): UserModuleAnswersGeneratedLinkedinProposition[] {
		return this._generatedUserModuleLinkedinProposition;
	}

	public get generatedUserModulePushSynthesis(): string {
		return this._generatedUserModulePushSynthesis;
	}

	public get generatedUserModulePushQuestionsSynthesis(): {
		[key: string]: string;
	} {
		return this._generatedUserModulePushQuestionsSynthesis;
	}

	public get generatedUserModuleSynthesis(): string {
		return this._generatedUserModuleSynthesis;
	}

	public get generatedUserModulePitch(): string {
		return this._generatedUserModulePitch;
	}

	public get isDone(): boolean {
		return this._isDone;
	}

	public get userId(): string {
		return this._userId;
	}

	public get moduleId(): string {
		return this._moduleId;
	}

	public get isStarted(): boolean {
		return this._isStarted;
	}

	public get coachComment(): string {
		return this._coachComment;
	}

	public get moduleRatingComment(): string {
		return this._moduleRatingComment;
	}

	public get moduleRatingValue(): number {
		return this._moduleRatingValue;
	}

	public get pages(): UserModulePage[] {
		return this._pages;
	}

	public get isDescriptionVisualized(): boolean {
		return this._isDescriptionVisualized;
	}

	public markDone() {
		this._isDone = true;
		this.markUpdated();
	}

	public markStarted() {
		this._isStarted = true;
		this.markUpdated();
	}

	public getActivityUrl(id: string): string {
		return this.pages.find((page) => page.pageId === id)?.activityUrl;
	}
}
